// @ts-nocheck
import {
    orderSalespersonStyles,
    OrderSalespersonStyles,
} from "@insite/content-library/Widgets/OrderDetails/OrderSalesperson";
import { infoProps } from "@store/Themes/common/props/info";

Object.assign<OrderSalespersonStyles>(orderSalespersonStyles, {
    wrapper: {},
    titleText: infoProps.label,
    orderSalesperson: infoProps.value,
});
